import { completeUpload, createDoc, updateDocStatus } from "./firestore";
import { uploadToStorage } from "./storage";
import {
  ProjectUploadPayload,
  ProjectFormInput,
} from "@/app/(workspace)/_types/project";

export async function uploadProjectFile(
  file: File,
  detail: ProjectFormInput,
  uuid: string
): Promise<{ docId: string; uuid: string; downloadUrl: string }> {
  const { title, options, output } = detail;
  let docId: string | null = null;

  try {
    // 1. Firestore 문서 생성
    docId = await createDoc({
      file,
      title: title,
      options: {
        quality: options.quality,
        sceneSize: options.sceneSize,
        autoColorCorrection: options.autoColorCorrection,
        ...(options.worldDensity && { worldDensity: options.worldDensity }),
      }
    } as ProjectUploadPayload);

    if (!docId) {
      throw new Error("Failed to create document in Firestore");
    }

    // 2. Storage 업로드 (pre-generated uuid 사용)
    const downloadUrl = await uploadToStorage(file, uuid);

    // 3. 성공 시 상태 업데이트
    await completeUpload(docId, uuid);

    return { docId, uuid, downloadUrl };
  } catch (err: any) {
    // 4. 실패 시 상태 업데이트 (docId가 있는 경우에만)
    if (docId) {
      try {
        await updateDocStatus(docId, "UPLOAD_ERROR");
      } catch (updateErr) {
        console.error(
          "[uploadProjectFile] Failed to update error status:",
          updateErr
        );
      }
    }
    throw err;
  }
}
